export default __webpack_public_path__ + "static/media/golosario.cca50019.png";